<template>
    <div class="loading" v-loading="loading"></div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import api from '@/api/api'

    export default {
        name: 'logout',
        computed: {
            ...mapGetters({
                authToken: 'getAuthToken'
            })
        },
        data() {
            return {
                loading: true
            }
        },
        created() {
            let self = this;
            console.log(this.authToken);
            api.logout().then(res => {
                self.$store.commit('setAuthToken', null);
                self.$router.push({
                    name: 'Index'
                })
            }).catch(function (error) {
                if (error.response.status === 401) {
                    self.$store.commit('setAuthToken', null);
                    self.$router.push({
                        name: 'Index'
                    })
                }
                if (error.response.status === 403) {
                    self.$store.commit('setAuthToken', null);
                    self.$router.push({
                        name: 'Index'
                    })
                }
            })
        }
    }
</script>

<style scoped>
    .loading {
        margin-top: 64px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Logout.vue